import { ChangeDetectionStrategy, Component, input, linkedSignal } from "@angular/core";

@Component({
  selector: "app-avatar",
  standalone: true,
  templateUrl: "./avatar.component.html",
  styleUrl: "./avatar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {

  readonly imageUrl = input<string | null>(null);

  readonly initials = input<string>("");

  readonly size = input<number>(36);

  // Resets to false whenever imageUrl changes, so a new valid photo recovers
  // from a previous image load error; onError flips it to true.
  protected readonly failed = linkedSignal<boolean>(() => {
    this.imageUrl();
    return false;
  });

  protected onError(): void {
    this.failed.set(true);
  }
}
